
<export-progress-modal
  v-if="state.isVisible"
  :config="config"
  :state="state"
  @fail="$emit('fail')"
  @success="$emit('success')"
  @retry="$emit('retry')"
  @toggle-modal="emitHideModal"
>
  <div :slot="ModalStatus.Confirmation" class="text-left">
    <scroll-area class="work-area">
      <fieldset>
        <legend class="text h4 w-bold">Choose properties to export</legend>
        <div class="check-container">
          <input
            id="export-fields-listView"
            name="export-fields"
            type="radio"
            v-model="fieldsToExport"
            value="listView"
          />
          <label for="export-fields-listView">List view properties</label>
        </div>
        <div class="check-container">
          <input id="export-fields-all" name="export-fields" type="radio" v-model="fieldsToExport" value="all" />
          <label for="export-fields-all">All properties</label>
        </div>
      </fieldset>
    </scroll-area>
    <div class="cta">
      <button class="btn block red outline" @click="emitHideModal">Cancel</button>
      <button class="btn block blue" @click="tryExport">Continue</button>
    </div>
  </div>
</export-progress-modal>
